export default "__VITE_PUBLIC_ASSET__b1c469eb__"